import actions from "./actions";
import {flattenTreeData} from "bukku/containers/AppPage/ControlPanel/Users/Permission/helper";
import { filterKeys } from "./utils/filterKeys";

let access;
const initState = {
    accessCreateState: false,
    accessCreateResult: {},
    accessReadAllState: false,
    accesses: [],
    accessReadState: false,
    accessReadResult: {},
    access: {
        type: null,
        manage_users: true,
        manage_billing: true,
        permissions: {},
    },
    type: undefined,
    accessUpdateState: false,
    accessUpdateResult: {},
    accessInviteState: false,
    accessDeleteState: false,
    makeOwnerState: false,
    accessesPagination: {},
    clientId: undefined,
    updateUserPartnerAccessState: false,
    updateUserPartnerAccessResult: false,

    permissionTreeModalVisible: false,

    permissionKeys: [],
    selectedPermissionKeys: [],
    selectedPermissionKeysParentOnly: [],
};

/**
 * @param {*} permissions - permission object
 * @param {boolean} [hideSubmoduleKeys=false] - true will only return basic permission keys (no submodules)
 * @return {*}
 */
function getPermissionKeys(permissions, hideSubmoduleKeys = false) {
    // const permissionKeys2 = [];
    // Object.keys(permissions).forEach(key => {
    //     const isModifier = key.includes('modifiers');
    //     const isSubmodule = key.includes('.') && !isModifier;
    //     if (!isModifier) {
    //         if (hideSubmoduleKeys && isSubmodule)
    //             return;
    //         permissionKeys2.push(key);
    //     }
    // });
    const permissionKeys = filterKeys(Object.keys(permissions), true, hideSubmoduleKeys, hideSubmoduleKeys);

    // console.log('aaa permissionKeys, permissionKeys2', permissionKeys, permissionKeys2, _.isEqual(permissionKeys, permissionKeys2));
    function getIndex(key) {
        return flattenTreeData.findIndex(d => d.key === key);
    }

    return permissionKeys.filter(key => getIndex(key) >= 0).sort((a, b) => getIndex(a) - getIndex(b));
}

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.CREATE_ACCESS_REQUEST:
            return {
                ...state,
                accessCreateState: 'request',
            };
        case actions.CREATE_ACCESS_SUCCESS:
            return {
                ...state,
                accessCreateState: 'success',
                accessCreateResult: action.access,
            };
        case actions.READ_ACCESSES_REQUEST:
            return {
                ...state,
                accessReadAllState: 'request',
            };
        case actions.READ_ACCESSES_SUCCESS:
            return {
                ...state,
                accessReadAllState: 'success',
                accesses: action.accesses,
                // Antd Pagination props: https://ant.design/components/pagination/
                accessesPagination: {
                    total: action.accessesPagination.total,
                    current: action.accessesPagination.current_page,
                    pageSize: action.accessesPagination.per_page,
                    showSizeChanger: false,
                },
            };
        case actions.READ_ACCESSES_ERROR:
            return {
                ...state,
                accessReadAllState: 'error',
            };
        case actions.READ_ACCESS_REQUEST:
            return {
                ...state,
                accessReadState: 'request',
            };
        case actions.READ_ACCESS_SUCCESS: {
            let permissions = action?.access?.permissions;

            if (permissions === [])
                permissions = {};

            return {
                ...state,
                accessReadState: 'success',
                access: action.access,
                accessReadResult: action.access,
                type: action.access.type,
                permissionKeys: getPermissionKeys(permissions || {}), // unchanged value
                selectedPermissionKeys: getPermissionKeys(permissions || {}), // will change when check/uncheck
                selectedPermissionKeysParentOnly: getPermissionKeys(permissions || {}, true),
            };
        }
        case actions.ACCESS_SET: // Partial update
            access = {
                ...(action.reset ? initState.access : state.access),
                ...action.request,
            };

            return {
                ...state,
                access,
                type: access.type,
            };
        case actions.ACCESS_SET_TYPE:
            return {
                ...state,
                type: action.val,
            };
        case actions.UPDATE_ACCESS_REQUEST:
            return {
                ...state,
                accessUpdateState: 'request',
            };
        case actions.UPDATE_ACCESS_SUCCESS:
            return {
                ...state,
                accessUpdateState: 'success',
                accessUpdateResult: action.access,
            };
        case actions.INVITE_ACCESS_REQUEST:
            return {
                ...state,
                accessInviteState: 'request',
            };
        case actions.INVITE_ACCESS_SUCCESS:
            return {
                ...state,
                accessInviteState: 'success',
            };
        case actions.DELETE_ACCESS_REQUEST:
            return {
                ...state,
                accessDeleteState: 'request',
            };
        case actions.DELETE_ACCESS_SUCCESS:
            return {
                ...state,
                accessDeleteState: 'success',
            };
        case actions.MAKE_OWNER_REQUEST:
            return {
                ...state,
                makeOwnerState: 'request',
            };
        case actions.MAKE_OWNER_SUCCESS:
            return {
                ...state,
                makeOwnerState: 'success',
            };
        case actions.ACCESS_SET_CLIENT_ID:
            return {
                ...state,
                clientId: action.clientId,
            };
        case actions.UPDATE_USER_PARTNER_ACCESS_REQUEST:
            return {
                ...state,
                updateUserPartnerAccessState: 'request',
            };
        case actions.UPDATE_USER_PARTNER_ACCESS_SUCCESS:
            return {
                ...state,
                updateUserPartnerAccessState: 'success',
                updateUserPartnerAccessResult: action.partner_manage_users,
            };
        case actions.RESET_ACCESS:
            return {
                ...initState,
            };
        case actions.TOGGLE_PERMISSION_TREE_MODAL:
            return {
                ...state,
                permissionTreeModalVisible: action.value,
            };
        case actions.SET_PERMISSION_KEYS:
            return {
                ...state,
                selectedPermissionKeys: action.keys,
                selectedPermissionKeysParentOnly: action.keys.filter(k => !k.includes('.')),
            };
        default:
            return state;
    }
}
